import { Keyboard, Mousewheel, Pagination } from 'swiper';
// Slides
import { Swiper } from 'swiper/react';

import styles from '@/components/swiper/Swiper.module.css';

interface VerticalSwiperProps {
  children: React.ReactNode;
}

export const VerticalSwiper = ({ children }: VerticalSwiperProps) => {
  const pagination = {
    clickable: true,
    renderBullet: function (index: any, className: any) {
      return '<span class="' + className + '">' + (index + 1) + '</span>';
    },
  };

  return (
    <Swiper
      className={styles.content}
      direction='vertical'
      initialSlide={0}
      keyboard={true}
      modules={[Pagination, Mousewheel, Keyboard]}
      mousewheel={true}
      pagination={pagination}
      speed={400}
      style={{ height: '100%' }}>
      {children}
    </Swiper>
  );
};
